module.exports = __webpack_public_path__ + "static/opadeyi-c9d35b7e4542eeca6ba0e9fa9f6bc308.png";